<template>
  <CContainer v-if="user">
    <CRow>
      <CCol md="12" class="text-end">
        <HelpCenterButton content-key="profile_settings_up_right" />
      </CCol>
    </CRow>
    <CRow class="justify-content-center mt-5">
      <CCol md="5" class="text-center">
        <Avatar :user="user" @change-avatar="setAvatar" />
        <h2 class="mt-3">
          {{ user.first_name + " " + user.last_name }}
        </h2>
      </CCol>
    </CRow>

    <CRow
      class="mt-5"
      :class="{
        'justify-content-center':
          userRole != 'staff' || userRole != 'admin' || userRole != 'teacher'
      }"
    >
      <CCol md="5">
        <ProfileSettingForm
          :active-appoinment-module-options="activeAppoinmentModuleOptions"
          :user="user"
          :avatar="avatar"
          :is-active-appoinment-module="isActiveAppoinmentModule"
        />
      </CCol>
      <CCol
        v-if="
          userRole == 'staff' || userRole == 'admin' || userRole == 'teacher'
        "
        md="7"
      >
        <AddLocations />
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import ProfileSettingForm from "./ProfileSettingForm.vue"
import AddLocations from "./AddLocations.vue"
import Avatar from "./Avatar.vue"
import HelpCenterButton from "@/components/HelpCenterButton"

export default {
  name: "StudentSettings",
  components: { ProfileSettingForm, AddLocations, Avatar, HelpCenterButton },
  props: [
    "user",

    "userRole",

    "isActiveAppoinmentModule",

    "activeAppoinmentModuleOptions"
  ],
  data() {
    return {
      avatar: null
    }
  },
  methods: {
    setAvatar(file) {
      this.avatar = file ? file : this.avatar
    }
  }
}
</script>

<style></style>
